import { Link } from 'react-router-dom';
import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';

const DeliveryReturnPage = () => {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Teslimat, İptal ve İade Koşulları
          </h1>
          <p className="text-gray-500 text-sm mb-8">
            Son Güncelleme Tarihi: {LEGAL_CONFIG.lastUpdated}
          </p>

          {/* Intro */}
          <div className="bg-primary/5 border border-primary/20 rounded-2xl p-6 mb-10">
            <p className="text-gray-700 leading-relaxed m-0">
              Bu sayfa; <strong>{LEGAL_CONFIG.companyName}</strong> tarafından işletilen{' '}
              <strong>Lezzet Yolda</strong> platformu üzerinden verilen siparişlerde geçerli
              teslimat koşullarını, sipariş iptal prosedürlerini ve iade politikasını açıklamaktadır.
              6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği
              hükümlerine uygun olarak hazırlanmıştır.
            </p>
          </div>

          {/* Section 1: Delivery */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Teslimat Koşulları</h2>

            <div className="space-y-4 text-gray-700">
              <p className="leading-relaxed">
                Siparişleriniz, platformda belirtilen tahmini teslimat süresi içerisinde
                restoran (SATICI) tarafından hazırlanarak kurye aracılığıyla belirttiğiniz
                adrese teslim edilir.
              </p>

              <div className="bg-gray-50 rounded-xl p-5 space-y-3">
                <h3 className="font-semibold text-gray-900">Teslimat Süreci</h3>
                <ul className="list-disc pl-5 space-y-2 text-sm">
                  <li>
                    Sipariş, restoranın onaylamasının ardından hazırlık sürecine girer;
                    hazırlık tamamlanınca kurye ataması yapılır.
                  </li>
                  <li>
                    Tahmini teslimat süreleri platform üzerinde sipariş ekranında
                    gösterilmektedir; bu süreler tahmini olup garanti niteliği taşımaz.
                  </li>
                  <li>
                    Siparişiniz, yasal 30 günlük azami süreyi aşmamak koşuluyla, adresinizin
                    uzaklığına bağlı olarak en kısa sürede teslim edilir.
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-5">
                <h3 className="font-semibold text-yellow-900 mb-2">Teslimatı Etkileyen Durumlar</h3>
                <p className="text-sm text-yellow-800 leading-relaxed">
                  Teslimat süreleri; hava koşulları, trafik yoğunluğu, restoran kapasitesi ve
                  benzeri dış etkenler nedeniyle değişiklik gösterebilir. Olası gecikmeler
                  platform bildirimleri aracılığıyla tarafınıza iletilecektir.
                </p>
              </div>

              <p className="leading-relaxed">
                Restoran (SATICI), sözleşme konusu ürünü eksiksiz, siparişte belirtilen
                niteliklere uygun ve yürürlükteki mevzuata uygun şekilde hazırlamak ve teslim
                etmekle yükümlüdür. Ürünün hazırlanması, kalitesi ve teslimat kalitesinden
                münhasıran SATICI sorumludur; <strong>{LEGAL_CONFIG.companyName}</strong> bu
                süreçte yalnızca aracı hizmet sağlayıcı konumundadır.
              </p>
            </div>
          </section>

          {/* Section 2: Cancellation */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Sipariş İptali</h2>

            <div className="space-y-4 text-gray-700">
              <p className="leading-relaxed">
                Sipariş iptali, siparişin durumuna bağlıdır. İptal talebinizi mümkün olan en
                kısa sürede iletmenizi öneririz.
              </p>

              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 rounded-xl text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">Sipariş Durumu</th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-900 border-b">İptal İmkânı</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr>
                      <td className="px-4 py-3 text-gray-700">Oluşturuldu (Onay Bekliyor)</td>
                      <td className="px-4 py-3 text-green-700 font-medium">✓ Mümkün — Platform üzerinden iptal edebilirsiniz</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-700">Hazırlanıyor</td>
                      <td className="px-4 py-3 text-red-700 font-medium">✗ Mümkün Değil</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-700">Hazır / Yolda</td>
                      <td className="px-4 py-3 text-red-700 font-medium">✗ Mümkün Değil</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-gray-700">Teslim Edildi</td>
                      <td className="px-4 py-3 text-red-700 font-medium">✗ Mümkün Değil — İade koşulları geçerlidir</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="leading-relaxed text-sm text-gray-600">
                İptal işleminiz restoran tarafından onaylandıktan sonra, ödemeniz iade
                edilecektir. Kredi kartı ödemelerinde iade, bankanızın işlem süreçlerine göre
                1–10 iş günü içinde hesabınıza yansır.
              </p>
            </div>
          </section>

          {/* Section 3: Right of Withdrawal */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Cayma Hakkı</h2>
            <div className="bg-red-50 border border-red-200 rounded-xl p-5">
              <p className="text-red-900 leading-relaxed text-sm">
                <strong>Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca;</strong> yiyecek
                ve içecek gibi çabuk bozulabilen veya son kullanma tarihi geçebilecek mallara
                ilişkin sözleşmelerde <strong>cayma hakkı kullanılamaz</strong>. Bu kapsamda,
                ALICI tarafından verilen yemek siparişlerinde, siparişin restoran tarafından
                hazırlanmaya başlanmasından sonra cayma ve iade hakkı bulunmamaktadır.
              </p>
            </div>
          </section>

          {/* Section 4: Return */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. İade Koşulları</h2>

            <div className="space-y-4 text-gray-700">
              <p className="leading-relaxed">
                Gıda ürünlerinin niteliği gereği genel iade hakkı bulunmamaktadır. Ancak
                aşağıdaki durumlarda iade veya telafi talebinde bulunabilirsiniz:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Teslim edilen ürünün siparişinizden farklı olması,</li>
                <li>Üründe eksiklik bulunması,</li>
                <li>Ürünün hasarlı veya bozuk olması.</li>
              </ul>

              <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
                <h3 className="font-semibold text-blue-900 mb-2">İade / Şikayet Süreci</h3>
                <ol className="list-decimal pl-5 space-y-2 text-sm text-blue-800">
                  <li>Sorunu teslim anında kurye nezaretinde tespit edin veya teslimattan hemen sonra bildirin.</li>
                  <li>
                    Müşteri hizmetlerimize{' '}
                    <a href={`mailto:${LEGAL_CONFIG.email}`} className="font-semibold underline">
                      {LEGAL_CONFIG.email}
                    </a>{' '}
                    adresinden veya{' '}
                    <a href="tel:+908503074858" className="font-semibold underline">destek hattımızdan</a>{' '}
                    ulaşın.
                  </li>
                  <li>Restoran (SATICI) onayıyla ücret iadesi veya ürünün yeniden gönderimi sağlanır.</li>
                </ol>
              </div>

              <div className="bg-gray-50 rounded-xl p-5">
                <h3 className="font-semibold text-gray-900 mb-2">Ücret İadesi Süresi</h3>
                <p className="text-sm leading-relaxed">
                  Onaylanan ücret iadeleri, ödeme yönteminize bağlı olarak bankanızın işlem
                  süreçlerine göre <strong>1–10 iş günü</strong> içerisinde hesabınıza yansıtılacaktır.
                  Nakit ödemelerde iade, anlaşılacak yöntemle gerçekleştirilir.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5: Contact */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. İletişim</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Teslimat, iptal veya iade konularında yardım almak için aşağıdaki kanallardan
              bize ulaşabilirsiniz:
            </p>
            <ul className="list-none pl-0 space-y-2 text-gray-700">
              <li>
                <strong>E-posta:</strong>{' '}
                <a href={`mailto:${LEGAL_CONFIG.email}`} className="text-primary hover:underline">
                  {LEGAL_CONFIG.email}
                </a>
              </li>
              <li>
                <strong>Telefon:</strong>{' '}
                <a href={`tel:${LEGAL_CONFIG.phone}`} className="text-primary hover:underline">
                  {LEGAL_CONFIG.phone}
                </a>
              </li>
              <li>
                <strong>Adres:</strong> {LEGAL_CONFIG.fullAddress}
              </li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4 text-sm">
              Uyuşmazlık halinde; T.C. Ticaret Bakanlığı'nca ilan edilen değere kadar Tüketici
              Hakem Heyetleri, bu değeri aşan uyuşmazlıklarda ise yerleşim yerinizdeki
              Tüketici Mahkemeleri yetkilidir.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
            <Link to="/mesafeli-satis-sozlesmesi" className="text-primary hover:underline font-medium">
              Mesafeli Satış Sözleşmesi
            </Link>
            <Link to="/terms" className="text-primary hover:underline font-medium">
              Kullanım Koşulları
            </Link>
            <Link to="/privacy" className="text-primary hover:underline font-medium">
              Gizlilik Politikası
            </Link>
            <Link to="/" className="text-primary hover:underline font-medium">
              ← Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DeliveryReturnPage;
